// FLAGS: none
// The interaction-event type and section enums the tracking hooks send to the API.
export enum VitalityCheckinEventType {
  VitalityCheckStart = "VitalityCheckStart",
  VitalityCheckNextPage = "VitalityCheckNextPage",
  VitalityCheckFinish = "VitalityCheckFinish",
  VitalityCheckViewResults = "VitalityCheckViewResults",
  VitalityCheckViewRecommendations = "VitalityCheckViewRecommendations",
  VitalityCheckStartFollowUp = "VitalityCheckStartFollowUp",
  VitalityCheckProgressRestored = "VitalityCheckProgressRestored",
  VitalityCheckinProgressDiscarded = "VitalityCheckinProgressDiscarded",
}

export enum ChatBotEventType {
  SameExpertSelected = "SameExpertSelected",
  ExpertProfilesOffered = "ExpertProfilesOffered",
  ExpertSelected = "ExpertSelected",
  TimeSlotOffered = "TimeSlotOffered",
  MoreTimeSlotsExplored = "MoreTimeSlotsExplored",
  TimeSlotSelected = "TimeSlotSelected",
  SessionBooked = "SessionBooked",
  ContentRecommended = "ContentRecommended",
  InsightChipSelected = "InsightChipSelected",
}

export enum SearchEventType {
  SearchPerformed = "SearchPerformed",
}

export enum AuthEventType {
  Login = "Login",
  RefreshTokenValidation = "RefreshTokenValidation",
}

export type InteractionEventType =
  | VitalityCheckinEventType
  | SearchEventType
  | AuthEventType
  | ChatBotEventType;

export enum AIGuideFeedbackEventType {
  ThumbsUpFeedbackSubmitted = "ThumbsUpFeedbackSubmitted",
  ThumbsDownFeedbackSubmitted = "ThumbsDownFeedbackSubmitted",
  ReasonsFeedbackSubmitted = "ReasonsFeedbackSubmitted",
}

export enum EventSection {
  LibraryVideosSection = "LibraryVideosSection",
  ThemesSection = "ThemesSection",
  LibrarySpacesSection = "LibrarySpacesSection",
  VitalityCheckin = "VitalityCheckin",
  VitalityCheckRecommendations = "VitalityCheckRecommendations",
  SpaceSessionRegistration = "SpaceSessionRegistration",
  Booking = "Booking",
  Search = "Search",
  Dashboard = "Dashboard",
  DashboardNextSteps = "DashboardNextSteps",
  DashboardMoreContents = "DashboardMoreContents",
  Chatbot = "Chatbot",
  ArticleDialog = "ArticleDialog",
  VitalityCheckGrowthAreas = "VitalityCheckGrowthAreas",
  VitalityCheckStrengths = "VitalityCheckStrengths",
  VitalityCheckFullDetails = "VitalityCheckFullDetails",
  ManagerContent = "ManagerContent",
  LibraryShortsSection = "LibraryShortsSection",
  LibraryAudioSection = "LibraryAudioSection",
  AudioPage = "AudioPage",
  ShortsPage = "ShortsPage",
}

// Carried through react-router navigation so a listing page continues the
// explore journey that started elsewhere — without it every surface mints its
// own correlationId and the explore → filter chain cannot be joined.
export interface ExploreNavigationState {
  exploreCorrelationId: string;
  exploreSection: EventSection;
}
